import MuiGrid, { type GridProps } from "@mui/material/Grid";

export type { GridProps };

export const Grid = MuiGrid;
